import React, { createContext, useReducer, useContext } from 'react';

import {
  initialState,
  PaymentState,
  reducer,
  PaymentAction,
} from './paymentsReducer';

interface PaymentsContextInterface {
  state: PaymentState;
  dispatch: React.Dispatch<PaymentAction>;
}

export const PaymentsContext = createContext<PaymentsContextInterface>({
  state: initialState,
  dispatch: () => {},
});

const PaymentStoreProvider = ({
  children,
}: React.PropsWithChildren): React.ReactElement<any> => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PaymentsContext.Provider value={{ state, dispatch }}>
      {children}
    </PaymentsContext.Provider>
  );
};

const usePaymentsContext = () => useContext(PaymentsContext);

export { PaymentStoreProvider, usePaymentsContext };
